import React, { useState } from 'react';
import { FlatList, View } from 'react-native';
import { Icon } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { PollCampaignGoalProps, PollCampaignProps, PollSummaryProps } from '../../../store/types/auth_svc';


type PollCampaignGoalProgressProp = {
    height?:number,
    poll_campaign:PollCampaignProps,
    poll_campaign_goals:PollCampaignGoalProps[]
}

const PollCampaignGoalProgress = ({ poll_campaign_goals, poll_campaign, height }: PollCampaignGoalProgressProp) => {
    const [ progress_details, setProgressDetails ] = useState({ x : 0, y: 0, width: 0, height:0 })
    const [ goals_expanded, setGoalsExpanded ] = useState(false)

    const renderGoals = (data: { item:PollCampaignGoalProps, index:number }) => {
        return (
            <View style={{ flexDirection:'row', padding:5 }}>
                <Text size={12} color={Colors.brand.midnight} weight='regular'>{data.item.goal_total} Responses: </Text>
                <Text size={12} color={Colors.brand.midnight} weight='semibold'>{data.item.goal_description}</Text>
            </View>
        )
    }


    if(poll_campaign_goals.length == 0){ return <></> }
    const max_goal = poll_campaign_goals.sort((a,b) => b.goal_total - a.goal_total)[0].goal_total
    let pct_complete = poll_campaign.total_responses / max_goal
    if(pct_complete > 1){ pct_complete = 1 }
    return (
        <TouchableOpacity onPress={() => setGoalsExpanded(!goals_expanded)}>
            <View nativeID='goal_header' style={{ flexDirection:'row', alignItems:'flex-end', justifyContent:'space-between', marginBottom:5 }}>
                <Text size={14} weight='bold' color={Colors.shades.white}>Campaign Goals</Text>
                <Text size={12} color={Colors.shades.white} weight='regular'>Total Responses: {poll_campaign.total_responses}</Text>
            </View>
            <View style={{ height:height??40, backgroundColor:Colors.shades.white, borderRadius:8, borderBottomRightRadius:goals_expanded?0:8, borderBottomLeftRadius:goals_expanded?0:8 }} onLayout={(ev) => {
                const { height, width, x, y } = ev.nativeEvent.layout
                setProgressDetails({ height, width, x, y })
            }}>
                <View style={{ position:'absolute', left:0, top:0, bottom:0, width:progress_details.width * pct_complete, backgroundColor:Colors.highlights.highlight400Faded }} />
                    {poll_campaign_goals.sort((a,b) => a.goal_total - b.goal_total).map((pcg, i) => {
                        let loc = 1 - (pcg.goal_total / max_goal)
                        return (
                            <View>
                                <View style={{ position:'absolute', flex:1, justifyContent:'center', alignItems:'center', marginRight:8, padding:5, borderRightWidth:1, borderColor:Colors.brand.midnight, height:height?height:38, right:loc * progress_details.width}}>
                                    <Text size={12} weight={pcg.goal_progress_status == 'complete' ? 'bold' : 'semibold'} color={Colors.brand.midnight} textAlign='right'>G{i + 1}</Text>
                                    <View style={{ position:'absolute', bottom:-15, right:0 }}>
                                        <Text size={12} weight='semibold' color={Colors.shades.white}>{pcg.goal_total}</Text>
                                    </View>
                                </View>
                            </View>
                        )
                    })}
                    <View style={{ flex:1,justifyContent:'flex-end', alignItems:'center' }}>
                        <View style={{ borderRadius:100, marginBottom:goals_expanded?5:-10, padding:5, backgroundColor:Colors.shades.white, ...local_styles.raised }}>
                            <Icon name={goals_expanded?'chevron-up':'chevron-down'} size={12} type='feather' color={Colors.brand.midnight} />
                        </View>
                    </View>                    
                </View>
            {goals_expanded ?
            <View style={{ padding:10, backgroundColor:Colors.shades.white, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <FlatList
                    data={poll_campaign_goals}
                    renderItem={renderGoals}
                />
            </View>
            :
            <></>}
        </TouchableOpacity>
    )

}


const local_styles = {
    raised: { shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }
}

export default PollCampaignGoalProgress